/**
 * 361 Sleep — Section 10
 * Line-by-line reveal for «الإتقان في التفاصيل»:
 * each column draws its rail while cream dots and specs land in sequence.
 */
(function () {
  'use strict';

  var BOOTED = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap && window.ScrollTrigger) {
      fn(window.gsap, window.ScrollTrigger);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(timer);
        fn(window.gsap, window.ScrollTrigger);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initSection(section, gsap) {
    var head = section.querySelector('[data-details-head]');
    var grid = section.querySelector('[data-details-grid]');
    var cols = section.querySelectorAll('[data-details-col]');
    if (!grid || !cols.length) return;

    if (section._detailsListCtx) {
      section._detailsListCtx.revert();
      section._detailsListCtx = null;
    }

    var ctx = gsap.context(function () {
      var mm = gsap.matchMedia();

      mm.add('(prefers-reduced-motion: reduce)', function () {
        var rails = section.querySelectorAll('[data-details-rail]');
        var dots = section.querySelectorAll('[data-details-dot]');
        var texts = section.querySelectorAll('.details361__item-text');
        gsap.set([head, rails, dots, texts].filter(Boolean), { clearProps: 'all' });
        gsap.set(rails, { scaleY: 1 });
        gsap.set(dots, { scale: 1, opacity: 1 });
        gsap.set(texts, { opacity: 1, x: 0 });
      });

      mm.add('(prefers-reduced-motion: no-preference)', function () {
        var rails = section.querySelectorAll('[data-details-rail]');
        var dots = section.querySelectorAll('[data-details-dot]');
        var texts = section.querySelectorAll('.details361__item-text');
        var step = 0.14;
        var itemsPerCol = cols[0].querySelectorAll('[data-details-item]').length || 4;
        var railDur = Math.max(0.75, itemsPerCol * step + 0.12);

        gsap.set(rails, { scaleY: 0, transformOrigin: 'top center' });
        gsap.set(dots, { scale: 0, opacity: 0, transformOrigin: 'center center' });
        gsap.set(texts, { opacity: 0, x: 18 });
        if (head) gsap.set(head, { opacity: 0, y: 16 });

        var tl = gsap.timeline({
          defaults: { ease: 'power2.out' },
          scrollTrigger: {
            trigger: grid,
            start: 'top 78%',
            toggleActions: 'play none none none'
          }
        });

        if (head) {
          tl.to(head, { opacity: 1, y: 0, duration: 0.6 }, 0);
        }

        /* Columns cascade right→left (DOM order is already RTL visual order) */
        Array.prototype.forEach.call(cols, function (col, colIndex) {
          var colRail = col.querySelector('[data-details-rail]');
          var colDots = col.querySelectorAll('[data-details-dot]');
          var colTexts = col.querySelectorAll('.details361__item-text');
          var colStart = 0.2 + colIndex * 0.12;

          if (colRail) {
            tl.to(
              colRail,
              {
                scaleY: 1,
                duration: railDur,
                ease: 'power1.inOut'
              },
              colStart
            );
          }

          if (colDots.length) {
            tl.to(
              colDots,
              {
                scale: 1,
                opacity: 1,
                duration: 0.4,
                ease: 'back.out(2.1)',
                stagger: step
              },
              colStart + 0.1
            );
          }

          if (colTexts.length) {
            tl.to(
              colTexts,
              {
                opacity: 1,
                x: 0,
                duration: 0.5,
                ease: 'power3.out',
                stagger: step
              },
              colStart + 0.16
            );
          }
        });
      });
    }, section);

    section._detailsListCtx = ctx;
  }

  function boot() {
    whenGsap(function (gsap, ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      document.querySelectorAll('[data-details361]').forEach(function (section) {
        initSection(section, gsap);
      });

      if (!BOOTED) {
        BOOTED = true;
        window.addEventListener(
          'load',
          function () {
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      }
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-details361]') && !(root.matches && root.matches('[data-details361]'))) {
      return;
    }
    boot();
  });
})();
